import { render, staticRenderFns } from "./donate.vue?vue&type=template&id=4fdb842d&scoped=true"
import script from "./donate.vue?vue&type=script&lang=js"
export * from "./donate.vue?vue&type=script&lang=js"
import style0 from "./donate.vue?vue&type=style&index=0&id=4fdb842d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdb842d",
  null
  
)

export default component.exports